import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import Responseloader from "./../../../Forms/ShortCutComponents/ResponseLoader";
// import "./myReactSelect.css";
import { Col, Row, Container, FormGroup, Input, Label } from "reactstrap";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
// import "./formsTable.css";
// import "./baseForms.css";
import { checkPermission, check_Bussiness_Permission } from "../../../../Helper";
import axios from "axios";
import { baseurl } from "../../../../baseurl";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

let companyId = localStorage.getItem("companyId");
let username = localStorage.getItem("username");
var token = localStorage.getItem("token");

export default function PartyOverview(props) {
  const [table, setTable] = useState({
    OverViewDataTable: [],
  });
  const [loadingResponse, setLoadingResponse] = useState(false);
  const [printData, setPrintData] = useState([]);
  const [footerData, setFooterData] = useState([]);
  const [nextPrintPage, setNextPrintPage] = useState([]);
  const [nextPrintPageFooter, setNextPrintPageFooter] = useState([]);
  const [isDollarjnction, setIsDollarjnction] = useState(false);
  const [isEggSpectation, setISEggSpecation] = useState(false);

  useEffect(() => {
    console.log("ffff", props);
    const id = props.location.state?.id;
    // const id = 410;
    const url = props.location.state?.goBackUrl;
    if (id) {
      getDataWithId(id);
    }
    checkpermission();
  }, []);

  const dynamicTopDesc = () => {
    return (
      <>
        <Row className="print-header bg-white">
          <Container>
            <Row style={{ backgroundColor: "white" }}>
              <Col style={{ backgroundColor: "white" }} md="4">
                <h5 className="voucherNo" style={{ textAlign: "left" }}>
                  Voucher No:{" "}
                  <span className="h5 text-muted">{printData[0]?.docNo}</span>
                </h5>
              </Col>
              <Col style={{ backgroundColor: "white" }} md="4">
                {" "}
                <h1 className="companyName" style={{ textAlign: "center" }}>
                  {localStorage.getItem("companyName")}
                </h1>
                <h5 className="invBookDesc" style={{ textAlign: "center" }}>
                  {" "}
                  <span className="h5">{printData[0]?.invBookDesc}</span>
                </h5>
              </Col>
              <Col style={{ backgroundColor: "white" }} md="4">
                {" "}
                <h5 style={{ textAlign: "right" }}>
                  Date :{" "}
                  <span className="h5 text-muted">{printData[0]?.date}</span>
                </h5>
              </Col>
              <Col style={{ backgroundColor: "white" }} md="6">
                <h5 className="voucherNo" style={{ textAlign: "left" }}>
                  Cash/Bank:{" "}
                  <span className="h5 text-muted">{printData[0]?.ACCOUNT_NAME}</span>
                </h5>
              </Col>
              <Col style={{ backgroundColor: "white" }} md="6">
                <h5 className="voucherNo" style={{ textAlign: "right" }}>
                  Bank Doc No:{" "}
                  <span className="h5 text-muted">{printData[0]?.bank_doc_no}</span>
                </h5>
              </Col>
            </Row>
          </Container>
        </Row>
      </>
    );
  };
  const getDataWithId = (id) => {
    let totalRecordCheckForPrint;
    setLoadingResponse(true);
    axios
      .post(
        `${baseurl}/masterData/getPaymentJournalWithID`,
        { id, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((res) => {
        let response = res.data.data;

        console.log("getFooterDataWithId", getFooterDataWithId);
        console.log("hhhhhqq", response);

        const originalDate = response[0].date;
        const preparedBy = response[0].created_by_name;

        const formattedDate = formatDateDMY(originalDate);

        function formatDateDMY(inputDate) {
          // Create a Date object from the input date string
          const dateObj = new Date(inputDate);

          // Extract day, month, and year
          const day = String(dateObj.getDate()).padStart(2, "0");
          const month = String(dateObj.getMonth() + 1).padStart(2, "0"); // Months are zero-based
          const year = dateObj.getFullYear();

          // Assemble the formatted date string in "dd-mm-yyyy" format
          const formattedDate = `${day}-${month}-${year}`;

          return formattedDate;
        }

        console.log(formattedDate);

        let label;
        if (response.page_size === "F") {
          label = "Full";
        } else {
          label = "Half";
        }
        const formValuesjournalDet = [];
        console.log(response[0]);
        for (let i = 0; i < response.length; i++) {
          formValuesjournalDet.push({
            concatenatedCode: `${response[i].acc_lov_code}-${
              response[i].sub_acct_code ? response[i].sub_acct_code : "0000"
            }`,
            concatenatedDesc: `${response[i].acc_lov_desc}${
              response[i].sub_acct_desc ? response[i].sub_acct_desc : ""
            }`,
            unit: response[i].sub_inv_desc,
            costCenter: response[i].cost_center_desc,
            debit: response[i].debit,
            credit: response[i].credit,
            docNo: response[i].docNo,
            naration: response[i].reason,
            date: formattedDate,
            preparedBy: preparedBy,
            invBookDesc: response[i].INV_BOOK_DESC,
            INV_BOOK_ID: response[i].INV_BOOK_ID,
            ACCOUNT_NAME: response[i].ACCOUNT_NAME,
            bank_doc_no: response[i].bank_doc_no,
            name: response[i].Name,
            lineNrrations: response[i].custom_remarks,
            billReference: response[i].bill_ref_no,
          });
        }
        console.log("hhhhhqq", formValuesjournalDet);
        totalRecordCheckForPrint = formValuesjournalDet.length;
        setPrintData(formValuesjournalDet);
        // checkpermission(formValuesjournalDet);
        return getFooterDataWithId(response[0]?.INV_BOOK_ID);
      })
      .then((footerLength) => {
        // The length of formValuesFooterData from getFooterDataWithId is available here
        console.log("Footer length:", footerLength);
        console.log("totalRecordCheckForPrint:", totalRecordCheckForPrint);
        if (footerLength >= 4) {
          if (totalRecordCheckForPrint > 2 && totalRecordCheckForPrint < 9) {
            setNextPrintPage(true);
          } else if (
            totalRecordCheckForPrint > 10 &&
            totalRecordCheckForPrint < 17
          ) {
            setNextPrintPage(true);
          } else if (
            totalRecordCheckForPrint > 18 &&
            totalRecordCheckForPrint < 25
          ) {
            setNextPrintPage(true);
          } else if (
            totalRecordCheckForPrint > 26 &&
            totalRecordCheckForPrint < 32
          ) {
            setNextPrintPage(true);
          }
        } else {
          if (totalRecordCheckForPrint > 4 && totalRecordCheckForPrint < 9) {
            setNextPrintPage(true);
          } else if (
            totalRecordCheckForPrint > 12 &&
            totalRecordCheckForPrint < 17
          ) {
            setNextPrintPage(true);
          } else if (
            totalRecordCheckForPrint > 20 &&
            totalRecordCheckForPrint < 25
          ) {
            setNextPrintPage(true);
          } else if (
            totalRecordCheckForPrint > 29 &&
            totalRecordCheckForPrint < 34
          ) {
            setNextPrintPage(true);
          } else {
            setNextPrintPage(false);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(function () {
        setLoadingResponse(false);
      });
  };
  const checkpermission = async () => {
    try {
      let checkBussinessPermission = await check_Bussiness_Permission();
      let { isDollarjnction, isEggSpectation } = checkBussinessPermission;

      isDollarjnction ? setIsDollarjnction(true) : setIsDollarjnction(false);
      isEggSpectation ? setISEggSpecation(true) : setISEggSpecation(false);
    } catch (error) {
      console.error("Error checking business permission:", error);
    }
  };
  const getFooterDataWithId = async (id) => {
    setLoadingResponse(true);
    try {
      try {
        const res = await axios.post(
          `${baseurl}/masterData/getDocFooterSetupId`,
          { id, companyId: companyId, username: username },
          {
            headers: {
              authorization: token,
            },
          }
        );
        let response = res.data.data[0];
        console.log("hhhhh", response);
        let label;
        if (response.page_size === "F") {
          label = "Full";
        } else {
          label = "Half";
        }
        const formValuesFooterData = [];

        if (response.desc1 !== " ") {
          formValuesFooterData.push({
            desc: response.desc1,
            enteredBy: response.Ent_by_1,
          });
        }
        if (response.desc_2 !== " ") {
          formValuesFooterData.push({
            desc: response.desc_2,
            enteredBy: response.Ent_by_2,
          });
        }
        if (response.desc_3 !== " ") {
          formValuesFooterData.push({
            desc: response.desc_3,
            enteredBy: response.Ent_by_3,
          });
        }
        if (response.desc_4 !== " ") {
          formValuesFooterData.push({
            desc: response.desc_4,
            enteredBy: response.Ent_by_4,
          });
        }
        if (response.desc_5 !== " ") {
          formValuesFooterData.push({
            desc: response.desc_5,
            enteredBy: response.Ent_by_5,
          });
        }
        if (response.desc_6 !== " ") {
          formValuesFooterData.push({
            desc: response.desc_6,
            enteredBy: response.Ent_by_6,
          });
        }
        console.log("hhhhh>", formValuesFooterData);
        if (formValuesFooterData.length > 3) {
          setNextPrintPageFooter(true);
        } else {
          setNextPrintPageFooter(false);
        }
        setFooterData(formValuesFooterData);
        return formValuesFooterData.length;
      } catch (err) {
        console.log(err);
      }
    } finally {
      setLoadingResponse(false);
    }
  };



  const downloadPDF = () => {
    const input = document.getElementById("pdfContent"); // The main wrapper

    html2canvas(input, {
      scale: 1, // Better resolution
      useCORS: true,
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/jpeg", 0.8);
      const pdf = new jsPDF("p", "mm", "a4");
      const imgProps = pdf.getImageProperties(imgData);

      // Fit image to A4 page
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      // pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.addImage(
        imgData,
        "JPEG",
        0,
        0,
        pdfWidth,
        pdfHeight,
        undefined,
        "FAST"
      );

      pdf.save("JournalEntry.pdf");
    });
  };

  return (
    <>
      {loadingResponse ? (
        <Responseloader />
      ) : (
        <>
          <Col md="12" className="bg-white">
            <div style={{ textAlign: "end" }}>
              <button
                className="btn btn-primary mx-2 btn-sm"
                id="downloadPdfButton"
                onClick={downloadPDF}
              >
                Download as PDF
              </button>

              <Link
                to={{
                  pathname: "/receiptJournalOverview",
                }}
              >
                <button
                  className="btn btn-primary m-1  btn-sm"
                  id="printPageButton"
                  onClick={() => {}}
                >
                  Back
                </button>
              </Link>
            </div>
          </Col>
          <Container className="bg-white">
            <Row className="bg-white w-100"></Row>
          </Container>
          <div id="pdfContent page-container">
            <Row className="app-body-Invoice bg-white rounded-lg ">
              <Col xs="12" className="mb-5">
                <div id="pdfContent">
                  <br></br>
                  <br></br>

                  <div>{dynamicTopDesc()}</div>
                  <Row className="my-1 main-content">
                    <Container style={{ marginTop: "-5rem" }}>
                      <table className="my-table">
                        <thead>
                          <tr style={{ backgroundColor: "white" }}>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                          </tr>
                          <tr style={{ backgroundColor: "white" }}>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                          </tr>
                          <tr style={{ backgroundColor: "white" }}>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                          </tr>
                          <tr style={{ backgroundColor: "white" }}>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                          </tr>
                          <tr style={{ backgroundColor: "white" }}>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                          </tr>
                          <tr style={{ backgroundColor: "white" }}>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                          </tr>
                          <tr style={{ backgroundColor: "white" }}>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                          </tr>
                          <tr>
                            <th
                              style={{
                                border: "1px solid black",
                                width: "100px",
                              }}
                            >
                              Account Code
                            </th>
                            <th
                              style={{
                                border: "1px solid black",
                                width: "400px",
                              }}
                            >
                              Description
                            </th>
                            <th
                              style={{
                                border: "1px solid black",
                                width: "100px",
                              }}
                            >
                              Unit
                            </th>
                            {isDollarjnction ? null : (
                              <th
                                style={{
                                  border: "1px solid black",
                                  width: "100px",
                                }}
                              >
                                Cost Center
                              </th>
                            )}
                            <th
                              style={{
                                border: "1px solid black",
                                width: "100px",
                              }}
                            >
                              Debit
                            </th>
                            <th
                              style={{
                                border: "1px solid black",
                                width: "100px",
                              }}
                            >
                              Credit
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {printData.map((row, index) => (
                            <tr key={row.id}>
                              <td
                                style={{
                                  border: "1px solid black",
                                  width: "100px",
                                }}
                              >
                                {row.concatenatedCode}
                              </td>

                              <td
                                style={{
                                  border: "1px solid black",
                                  width: "400px",
                                }}
                              >
                                {row.concatenatedDesc}
                                <p
                                  style={{
                                    fontSize: "15px",
                                  }}
                                >
                                  Doc#{row?.docNo+' | '} {row.lineNrrations}
                                </p>
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  width: "100px",
                                }}
                              >
                                {row.unit}
                              </td>
                              {isDollarjnction ? null : (
                                <td
                                  style={{
                                    border: "1px solid black",
                                    width: "100px",
                                  }}
                                >
                                  {row.costCenter}
                                </td>
                              )}
                              <td
                                style={{
                                  textAlign: "right",
                                  border: "1px solid black",
                                  width: "100px",
                                }}
                              >
                                {row.debit !== "" &&
                                row.debit !== null &&
                                row.debit !== undefined
                                  ? new Intl.NumberFormat("en-US", {
                                      style: "decimal", // Use "decimal" style instead of "currency"
                                      minimumFractionDigits: 2, // Keep two decimal places
                                      maximumFractionDigits: 2,
                                      useGrouping: true, // This keeps the thousand separator formatting
                                    }).format(parseFloat(row.debit))
                                  : null}
                              </td>

                              <td
                                style={{
                                  textAlign: "right",
                                  border: "1px solid black",
                                  width: "100px",
                                }}
                              >
                                {row.credit !== "" &&
                                row.credit !== null &&
                                row.credit !== undefined
                                  ? new Intl.NumberFormat("en-US", {
                                      style: "decimal", // Use "decimal" style instead of "currency"
                                      minimumFractionDigits: 2, // Keep two decimal places
                                      maximumFractionDigits: 2,
                                      useGrouping: true, // This keeps the thousand separator formatting
                                    }).format(parseFloat(row.credit))
                                  : null}
                              </td>
                            </tr>
                          ))}
                          <tr>
                            <td
                              style={{
                                border: "1px solid black",
                                fontWeight: "bold",
                              }}
                              colSpan={isDollarjnction ? 3 : 4}
                            >
                              Totals
                            </td>
                            <td
                              style={{
                                textAlign: "right",
                                border: "1px solid black",
                                fontWeight: "bold",
                              }}
                            >
                              {new Intl.NumberFormat("en-US", {
                                style: "decimal", // Use "decimal" style instead of "currency"
                                minimumFractionDigits: 2, // Keep two decimal places
                                maximumFractionDigits: 2,
                                useGrouping: true, // This
                              }).format(
                                printData.reduce(
                                  (sum, row) =>
                                    sum +
                                    (row.debit !== "" &&
                                    row.debit !== null &&
                                    row.debit !== undefined
                                      ? parseFloat(row.debit)
                                      : 0),
                                  0
                                )
                              )}
                            </td>
                            <td
                              style={{
                                textAlign: "right",
                                border: "1px solid black",
                                fontWeight: "bold",
                              }}
                            >
                              {new Intl.NumberFormat("en-US", {
                                style: "decimal", // Use "decimal" style instead of "currency"
                                minimumFractionDigits: 2, // Keep two decimal places
                                maximumFractionDigits: 2,
                                useGrouping: true, // This
                              }).format(
                                printData.reduce(
                                  (sum, row) =>
                                    sum +
                                    (row.credit !== "" &&
                                    row.credit !== null &&
                                    row.credit !== undefined
                                      ? parseFloat(row.credit)
                                      : 0),
                                  0
                                )
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                border: "1px solid black",
                                fontWeight: "bold",
                              }}
                              colSpan={isDollarjnction ? 3 : 4}
                            >
                               Net Receipt
                            </td>
                            <td
                              style={{
                                textAlign: "right",
                                border: "1px solid black",
                                fontWeight: "bold",
                              }}
                              colSpan = "2"
                            >
                           {new Intl.NumberFormat("en-US", {
  style: "decimal",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  useGrouping: true,
}).format(
(  printData.reduce(
    (sum, row) =>
      sum +
      (row.debit !== "" && row.debit != null
        ? parseFloat(row.debit)
        : 0),
    0
  ) -
  printData.reduce(
    (sum, row) =>
      sum +
      (row.credit !== "" && row.credit != null
        ? parseFloat(row.credit)
        : 0),
    0
  ) )* -1
)}

                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </Container>
                  </Row>
                  <Container
                    className="footer mt-5"
                    // className="footer"
                    style={{ backgroundColor: "white" }}
                  >
                    <Col md="4">
                      <h4>Naration:</h4>
                    </Col>
                    <Col
                      md="12"
                      className="border"
                      style={{ height: "4rem", marginBottom: "5rem" }}
                    >
                      <p>
                        {isEggSpectation && printData[0]?.billReference
                          ? printData[0]?.billReference
                          : printData[0]?.naration}
                      </p>
                    </Col>
                    <Row
                      className="mt-5 footerRows"
                      style={{
                        textAlign: "center",
                      }}
                    >
                      {footerData.map((row, index) => (
                       <Col
                            lg="4"
                            md="4"
                            sm="4"
                            className="px-4"
                            style={{
                              marginBottom: "3rem",
                              marginTop: row.enteredBy != 1 ? "1.3rem" : "0",
                            }}
                          >
                            <h5>
                              {index === 0 && !row.enteredBy
                                ? printData[0]?.preparedBy
                                : row.enteredBy}
                            </h5>
                            <hr
                              style={{
                                border: "1px solid ",
                                borderColor: "E4E5E6",
                                margin: "revert",
                              }}
                            />
                            <h4 key={row.id}>{row.desc}</h4>
                          </Col>
                      ))}
                    </Row>
                  </Container>
                </div>
              </Col>
            </Row>

            {/* Element to appear at the end of the last printed page */}
            {/* <div className="end-of-last-page">
            <h4>
              This content appears at the end of the last page when printed.
            </h4>
          </div> */}
          </div>
        </>
      )}
    </>
  );
}
